import axios from 'axios';

import { parameters } from '../../constants/parameters';
import { Translation } from '../../entities/translation';
import TranslationForm from '../../entities/form/translation';
import { Pagination } from '../../entities/pagination';
import * as genericApi from './generic-api';

export const list = async (
  token: string,
  params?: object,
): Promise<{ items: Translation[]; pagination: Pagination }> => {
  const url = `${parameters.api.baseUrl}/translations-crud`;

  return genericApi.list<Translation>(token, url, params);
};

export const one = async (token: string, id: string): Promise<Translation> => {
  const url = `${parameters.api.baseUrl}/translations-crud/${id}`;

  return genericApi.one<Translation>(token, url);
};

export const create = async (token: string, data: TranslationForm): Promise<Translation | undefined> => {
  const url = `${parameters.api.baseUrl}/translations-crud`;

  return genericApi.create<TranslationForm, Translation>(token, url, data);
};

export const update = async (
  token: string,
  id: number,
  data: Partial<TranslationForm>,
): Promise<Translation | undefined> => {
  const url = `${parameters.api.baseUrl}/translations-crud/${id}`;

  return genericApi.update<TranslationForm, Translation>(token, url, data);
};

export const remove = async (token: string, id: number): Promise<{ status: string }> => {
  const url = `${parameters.api.baseUrl}/translations-crud/${id}`;

  const response = await axios.delete(url, { headers: { Authorization: `Bearer ${token}` } });

  return response.data;
};
